import * as React from 'react';
import styled, { css } from 'styled-components';
import { Box, colors, fonts } from '@aksara-ui/core';
import { HeroStyled } from './HeroStyled';

import SignupHero from './imgs/SignupHero.svg';

interface AuthWrapperProps {
  className?: string;
  style?: React.CSSProperties;
  isSignupPage?: boolean;
}

export const Root = styled(Box)<AuthWrapperProps>`
  display: flex;
  flex-direction: ${props => (props.isSignupPage ? 'row-reverse' : 'row')};
  align-items: center;
  min-height: 100vh;
  overflow: auto;
  background-color: ${colors.grey01};
  font-family: ${fonts.system};
`;

export const AuthWrapper: React.FC<AuthWrapperProps> = ({ className, style, children, isSignupPage: isLoginPage }) => {
  return (
    <Root className={className} style={style} isSignupPage={isLoginPage}>
      <Box
        className="auth-welcome"
        display="flex"
        justifyContent={isLoginPage ? 'flex-end' : 'flex-start'}
        flex="0 0 520px"
        height="100vh"
        backgroundColor="grey01"
        css={css`
          transition: margin 300ms ease;
        `}
      >
        <HeroStyled src={SignupHero} />
      </Box>
      {children}
    </Root>
  );
};
